import React from 'react';
import UserForm from "src/components/account/UserForm";
import CloseAccountButton from "src/components/account/CloseAccountButton";
import Box from "@mui/material/Box";
import {TabContext, TabList, TabPanel} from "@mui/lab";
import {Tab, Typography} from "@mui/material";

const MyAccountDataPage = () => {
  const [tab, setTab] = React.useState("1");

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <TabContext value={tab}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <TabList onChange={handleChange}>
          <Tab label="Mijn gegevens" value="1" />
          <Tab label="Account sluiten" value="2" />
        </TabList>
      </Box>

      <TabPanel value="1">
        <Typography variant="h2" mb={2}>Mijn gegevens</Typography>
        <Typography variant="body1" mb={2}>
          Hier vind je een overzicht van je persoonlijke gegevens en instellingen. Pas de gegevens aan waar nodig maar let op: als je het emailadres aanpast verandert dit ook je gebruikersnaam om in te loggen.
        </Typography>
        <UserForm register={false} />
      </TabPanel>

      <TabPanel value="2">
        <Typography variant="h2" mb={2}>Account sluiten</Typography>
        <Typography variant="body1" mb={2}>
          Klik op onderstaande knop als je niet meer wil deelnemen aan onze testen en je gegevens bij ons wilt verwijderen.<br/>
          <br/>
          Let op: het verwijderen kan niet meer ongedaan worden gemaakt. Ook uw beschikbare saldo (indien van toepassing) zal verdwijnen.
        </Typography>
        <CloseAccountButton />
      </TabPanel>
    </TabContext>
  );
}

export default MyAccountDataPage;

MyAccountDataPage.propTypes = {};

MyAccountDataPage.defaultProps = {};
